import { useState } from "react";
import { BaseInput } from "shared/components/forms/BaseInput";
import { type CredentialFormProps } from "./types";
import { SyncOptionRadioGroup } from "./fields/SyncOptionRadioGroup";
import { BoolCheckbox } from "./fields/BoolCheckbox";
import { FormSection } from "./fields/FormSection";

const FEATURE_FIELDS = [
  ["appfolio_use_reports", "Use reports"],
  ["appfolio_use_property_groups", "Use property groups"],
  ["appfolio_enable_rently", "Enable Rently"],
  ["appfolio_use_supergood_api", "Enable Supergood API"]
] as const;

export const AppfolioCredentialForm = ({ register }: CredentialFormProps) => {
  const [showSupergood, setShowSupergood] = useState(false);
  const syncField = register("appfolio_sync");

  return (
    <>
      <BaseInput
        id="appfolio_url"
        label="URL"
        {...register("appfolio_url")}
        required
      />
      <BaseInput
        id="appfolio_username"
        label="Username"
        {...register("appfolio_username")}
        required
      />
      <BaseInput
        id="appfolio_password"
        label="Password"
        {...register("appfolio_password")}
        required
      />

      <SyncOptionRadioGroup
        field={syncField}
        bordered
        prose="Sync Appfolio status with the ability to submit applications"
      />

      <FormSection title="Features">
        {FEATURE_FIELDS.map(([key, label]) => (
          <BoolCheckbox key={key} field={register(key)} label={label} />
        ))}
      </FormSection>

      <div className="border-t border-alpha-40 pt-4">
        <BoolCheckbox
          label="Configure Supergood credentials"
          checked={showSupergood}
          onChange={setShowSupergood}
        />
      </div>

      {showSupergood && (
        <div className="flex flex-col gap-4">
          <BaseInput
            id="appfolio_supergood_username"
            label="Supergood Username"
            {...register("appfolio_supergood_username")}
          />
          <BaseInput
            id="appfolio_supergood_password"
            label="Supergood Password"
            {...register("appfolio_supergood_password")}
          />
          <BaseInput
            id="appfolio_supergood_mfa_phone"
            label="Supergood MFA Phone"
            {...register("appfolio_supergood_mfa_phone")}
          />
        </div>
      )}
    </>
  );
};
